import { SubscriptionPlans, SubscriptionPlanType } from '@pff-consumer/schema'

export const isMonthlyPlan = (plan: SubscriptionPlanType) => {
  return (
    plan === SubscriptionPlans.PREMIUM_MONTHLY_SEASON ||
    plan === SubscriptionPlans.PREMIUM_MONTHLY_SEASON_PASS ||
    plan === SubscriptionPlans.PREMIUM_MONTHLY_2024_DRAFT_EARLY ||
    plan === SubscriptionPlans.PREMIUM_MONTHLY_2024_DRAFT_PEAK
  )
}
